import { useCallback } from 'react';
import { isNullish } from '@/utils/predicates';
import { useFormatDate } from './useFormatDate';

interface DobInfo {
  dateOfBirth?: string | null;
  age?: number | null;
}

export const useFormatDob = () => {
  const formatDate = useFormatDate();

  return useCallback(
    (playerInfo?: DobInfo | null): string | undefined => {
      if (!playerInfo?.dateOfBirth || isNullish(playerInfo.age)) return undefined;
      return `${formatDate(playerInfo.dateOfBirth)} (${playerInfo.age})`;
    },
    [formatDate],
  );
};
